import script from "./UPhotoFrame.vue?vue&type=script&lang=ts&setup=true"
export * from "./UPhotoFrame.vue?vue&type=script&lang=ts&setup=true"

import "./UPhotoFrame.vue?vue&type=style&index=0&id=5d797e3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d797e3c"]])

export default __exports__